<template>
  <div>
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <el-input type="text" v-model="user_id" placeholder="User ID" />
      <el-date-picker
        v-model="date_range"
        type="daterange"
        class="mt10"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      first_name: '',
      surname: '',
      email: '',
      country: '',
      date_range: ''
    }
  },

  computed: {
    ...mapState('global', ['countries'])
  },

  methods: {
    ...mapActions('users', ['read']),
    ...mapActions('global', ['readCountries']),
    ...mapMutations('users', ['setPage', 'setPageSize', 'setDateRange']),

    filter() {
      this.setPage(1)
      this.read({
        first_name: this.first_name,
        surname: this.surname,
        email: this.email,
        country: this.country,
        date_start: this.date_range[0],
        date_end: this.date_range[1]
      })
    },

    clear() {
      this.read()
      this.first_name = ''
      this.surname = ''
      this.email = ''
      this.country = ''
      this.date_range = ''
    }
  },

  created() {
    this.readCountries()
  }
}
</script>
